import * as yup from 'yup'

export const buildDeleteRemoteConfigValidator = (key: string) => {
  return yup.object({
    confirmText: yup.string().test('confirmTextMatchesKey', `Type ${key} exactly`, (value) => {
      return (value ?? '').trim() === key
    }),
  })
}
